import React from "react";
import "./ParallaxSection.css";
import { Skeleton } from "antd";
export default function ParallaxSection({ parallaxData, height }) {
  // console.log(parallaxData[0]?.image.split("$")[0]?.split("#")[0])
  return (
    <div className="parallax-section-box">
      {parallaxData.length > 0 ? (
        <section
          className="parallax-section mb-4"
          style={{
            background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${
              parallaxData[0]?.image.split("$")[0]?.split("#")[0]
            })`,
            height: height,
          }}>
          <h2>{parallaxData[0]?.heading}</h2>
          {/* <h2>Handcrafted Beaded Beauty - Timeless Elegance, Modern Charm</h2> */}
          {/* Jewellery - The perfect punctuation to your personal style */}
          {/* <div className="mt-4 mt-lg-5">
              <a href={banners[0]?.slug} className="theme-btn">
                Explore More
              </a>
            </div> */}
        </section>
      ) : (
        <section className="parallax-section-skeleton mb-4">
          <Skeleton.Image className="h-100 w-100" />
        </section>
      )}
    </div>
  );
}
